module.exports = __webpack_public_path__ + "static/media/battles-tooltip-1.fd088b2c.png";